import React, { useEffect, useRef } from 'react';
import EditorJS from '@editorjs/editorjs';
import Header from '@editorjs/header';
import List from '@editorjs/list';
import Quote from '@editorjs/quote';
import Code from '@editorjs/code';
import Embed from '@editorjs/embed';
import Table from '@editorjs/table';
import ImageTool from '@editorjs/image';

interface EditorProps {
  onChange?: (data: any) => void;
}

export default function Editor({ onChange }: EditorProps) {
  const editorRef = useRef<EditorJS | null>(null);
  const holderId = 'editorjs-container';

  useEffect(() => {
    if (!editorRef.current) {
      editorRef.current = new EditorJS({
        holder: holderId,
        tools: {
          header: { class: Header as any, inlineToolbar: true },
          list: { class: List as any, inlineToolbar: true },
          quote: { class: Quote as any, inlineToolbar: true },
          code: { class: Code as any, inlineToolbar: true },
          embed: { class: Embed as any, inlineToolbar: true },
          table: { class: Table as any, inlineToolbar: true },
          image: {
            class: ImageTool,
            config: {
              uploader: {
                uploadByFile(file: File) {
                  return new Promise((resolve) => {
                    const fakeURL = URL.createObjectURL(file);
                    resolve({
                      success: 1,
                      file: {
                        url: fakeURL,
                      },
                    });
                  });
                },
                uploadByUrl(url: string) {
                  return Promise.resolve({
                    success: 1,
                    file: {
                      url: url,
                    },
                  });
                },
              },
            },
          },
        },
        data: {
          blocks: [
            { type: 'header', data: { text: '', level: 1 } },
          ],
        },
        onChange: async () => {
          if (onChange) {
            const data = await editorRef.current?.save();
            onChange(data);
          }
        },
      });
    }

    return () => {
      editorRef.current?.destroy();
      editorRef.current = null;
    };
  }, [onChange]);

  return (
    <div
      id={holderId}
      style={{
        border: '1px solid #ddd',
        borderRadius: 4,
        padding: 16,
        minHeight: 200,
        backgroundColor: '#fafafa',
      }}
    />
  );
}
